export enum SourcingLocationType {
    city = 'city',
    county = 'county',
    country = 'country',
    state = 'state',
    zipCode = 'zipCode',
    region = 'region',
    continent = 'continent',
    hemisphere = 'hemisphere',
    planet = 'planet'
}